export const ShopInfo = {
    "Name": "SAAVA",
    "Address": "Raopura , Jubilee Baug",
    "Phone": "+91 7283913949",
    "Whatsapp": "917283913949",
    "WhatsappMessageHeader": "Hello.Please find the below order.",
    "OpenTime": "10:30 AM",
    "CloseTime": "11:00 PM",
    "CartEmptyMessage": "Your cart is empty now. Add items to place order."
}